import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\graha\\source\\repos\\product-factory\\products\\02-property-compliance\\web\\node_modules\\next\\dist\\client\\app-dir\\link.js");
